export default "__VITE_ASSET__DA0iQCBk__"